export default __webpack_public_path__ + "static/media/Grips of the Primal Spirit.a28b8085.jpg";